import {memo} from "react";

export const AddTemplateIcon = memo(({className, ...props}) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 1.99998H6.00003C5.4696 1.99998 4.96089 2.21069 4.58581 2.58576C4.21074 2.96084 4.00003 3.46955 4.00003 3.99998V19.9999C4.00003 20.5303 4.21074 21.0392 4.58581 21.4142C4.96089 21.7893 5.4696 21.9999 6.00003 21.9999H18C18.5304 21.9999 19.0392 21.7893 19.4142 21.4142C19.7893 21.0392 20.0001 20.5303 20.0001 19.9999V7.99998M14 1.99998C14.3166 1.99946 14.6301 2.06157 14.9226 2.18274C15.2149 2.30391 15.4806 2.48174 15.7041 2.70597L19.2921 6.29397C19.5168 6.51749 19.6951 6.78332 19.8166 7.07613C19.9383 7.36895 20.0005 7.68294 20.0001 7.99998M14 1.99998V6.99998C14 7.26519 14.1054 7.51955 14.2929 7.70708C14.4805 7.89462 14.7348 7.99997 15 7.99997L20.0001 7.99998M9.00003 15H15M12 18V12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

AddTemplateIcon.displayName = "AddTemplateIcon";
